//请自行添加语言资源
const storageAssignAdjustingRecords = {
  plantName:'基地名称',
  appointmentNo:'预约单号',
  qcNo:'采样单号',
  vehicleNo:'车牌号',
  creator:'操作人',
  createTime:'操作日期',
  oldStorageCode:'原库位编码',
  oldStorageName:'原库位名称',
  storageCode:'调整后库位编码',
  storageName:'调整后库位名称',
  manualAppointReason:'库位调整原因',
};
export default storageAssignAdjustingRecords



// WEBPACK FOOTER //
// ./src/page/report/storageAssignAdjustingRecords/lang/storageAssignAdjustingRecords.en.js